import {
  instance as axios,
  setJwtToken,
} from '../../config/axiosInstance';

export const fetchConsultantPerformanceApi = async (data) => {
  const endPoint = `/admin/consultant-performance` +
    "?" +
    new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

export const fetchMainMetricsApi = async (data) => {
  const endPoint = `/admin/consultant-performance/main-metrics` +
    "?" +
    new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

export const fetchConsultantListApi = async (data) => {
  const endPoint = `/admin/consultant-performance/list` +
    "?" +
    new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

export const fetchConsultantPerformanceGraphApi = async (data) => {
  const endPoint = `/admin/consultant-performance/graph` +
    "?" +
    new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

export const fetchPerformanceSettingsApi = async () => {
  return await axios.get('/admin/consultant-performance/settings', setJwtToken());
};

export const savePerformanceSettingsApi = async (data) => {
  return await axios.put('/admin/consultant-performance/settings', data, setJwtToken());
};

export const fetchPerformanceAlertsApi = async (data = {}) => {
  const endPoint = `/admin/consultant-performance/alerts` +
    "?" +
    new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

export const fetchLowVmpsConsultantIdsApi = async (data = {}) => {
  const endPoint = `/admin/consultant-performance/alerts/low-vmps-ids` +
    "?" +
    new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

export const sendPerformanceOutreachApi = async (data = {}) => {
  return await axios.post('/admin/consultant-performance/outreach/send', data, setJwtToken());
};
